import * as React from 'react';

import { ICoreContext } from '@msdyn365-commerce/core';
import { IAppSettingsInContext } from '../../../settings/app.settings.autogenerated';

const PlaceholderImage: React.FC<{
    context: ICoreContext<IAppSettingsInContext>;
    baseClassName: string;
    hide?: boolean;
}> = ({ context, baseClassName, hide }) => {
    let emptyPlaceHolderImage = context.app.config?.placeholderImageName;
    let fallbackImageSource = context.request.apiSettings.baseImageUrl;
    if (fallbackImageSource?.endsWith('/')) {
        fallbackImageSource = fallbackImageSource.slice(0, -1);
    }
    if (emptyPlaceHolderImage) {
        emptyPlaceHolderImage = `${fallbackImageSource}${emptyPlaceHolderImage}`;
    }

    const image = emptyPlaceHolderImage ? (
        <img src={emptyPlaceHolderImage} title={'Placeholder image'} style={hide ? { opacity: 0 } : {}} />
    ) : (
        <div className={`${baseClassName}__current-image__placeholder`} style={hide ? { backgroundImage: 'none' } : {}} />
    );

    return image;
};

export default PlaceholderImage;
